module.exports = "/img/_/_/_/assets/images//frame_small.png?bdee0bfa3179530ed14a1a6375d119a9";